module.exports = __webpack_public_path__ + "static/media/flutter.d21f1eec.png";